import { withRouter } from 'react-router-dom';
import ReactWindowList from '../components/ReactWindowList';

export default withRouter(ReactWindowList);